import { Box, Grid } from "@mui/material";
import React from "react";
//MPOGLU;453137;09042025
interface ByzTitleBoxProps {
  title: string;
}

const ByzTitleBox: React.FC<ByzTitleBoxProps> = ({ title }) => {
  return (
    <Grid
      container
      sx={{
        margin: "8px",
        p: 2,
        borderBottom: "1px solid #E0E0E0",
        backgroundColor: "#63B4FF33",
        borderRadius: "10px",
      }}
    >
      <Box
        style={{
          fontWeight: "bold",
          fontSize: "1rem",
          color: "#2979C3",
        }}
      >
        {title}
      </Box>
    </Grid>
  );
};

export default ByzTitleBox;
